/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import Element from './Elements/Elements'
import { Grid, Button, Paper } from '@material-ui/core'

import CheckCircleOutlined from '@material-ui/icons/CheckCircleOutlined';


const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        // primary: {
        //     main: "#FF6600",  
        //     contrastText: "#FFFFFFFF"
        // },
        secondary: {
          main: '#f50157',
        },
      },
})

const styles = theme => ({

})

const clone = require('rfdc')()

class FlexForm extends Component {
    state = {
        submit: false
    }

    componentWillMount () {
        console.log('FlexForm Config Prop : ', this.props.config)
        this.setState({
            ...this.state, 
            config : this.props.config,
            fields_in_scope : this.props.fields_in_scope.map(field => {
                return field.name
            })
        }, () => {
            this.addIdToConfig()
            console.log('FlexForm Pre Mount State: ', this.state)
        })
    }

    componentDidUpdate (prevProps, prevState) {
        var equal = require('fast-deep-equal');
        console.log("FlexForm Config Update : Prop :", this.props.config)
        console.log("FlexForm Config Update : State :", this.state.config)
        if (equal(prevState.config, this.state.config)) {
            if (!equal(this.props.config, this.state.config)) {
                console.log("FlexForm Update : ***********Flex Form Updated Props************")
                this.setState({
                    ...this.state, 
                    config : this.props.config,
                    fields_in_scope : this.props.fields_in_scope.map(field => {
                        return field.name
                    })
                }, () => {
                    this.addIdToConfig()
                    // console.log('FlexForm State Update: ', this.state)
                })
            }
        }
    }

    handleSubmit = () => {

    }

    exportConfig = () => {

    }

    addIdToConfig = () => {
        let new_state = clone(this.state)
        new_state.config = this.addId(new_state.config, 0, null)
        if (this.props.fields_in_scope.length > 0) {
            this.replaceFieldsInScopeInConfig(new_state)
        } else {
            this.setState({...new_state}, () => {
                console.log('FlexForm State After IDs: ', this.state)
                this.props.update_parent(this.state.config)
            })
        }
    }

    replaceFieldsInScopeInConfig = (state) => {
        let new_state = clone(state)
        new_state.config = this.replaceFieldsinScope(new_state.config)

        this.setState({...new_state}, () => {
            console.log('FlexForm State Replacing FiS: ', this.state)
            this.props.update_parent(this.state.config)
        })
    }

    replaceFieldsinScope = (config) => {
        config.map((element) => {
            if (element.component !== 'group') {
                if (element.component === 'select' || element.component === 'multi_select') {
                    let options_index = element.component_params.findIndex(param => param.name === 'options')
                    if (element.component_params[options_index].value.list.length === 1 && element.component_params[options_index].value.list[0] === "$fieldsInScope") {
                        element.component_params[options_index].value.list = this.state.fields_in_scope
                    }
                }
            } else {
                element.elements = element.elements.map(element_group => {
                    return this.replaceFieldsinScope(element_group)
                })
            }
        })

        return config
    }

    addId = (config, depth, pId) => {
        config.map((element, i) => {
            if (element.component !== 'group') {
                if (pId !== null) {
                    element.id = pId + '/' + depth + '-' + i
                } else {
                    element.id = depth + '-' + i
                }
            } else {
                if (pId !== null) {
                    element.id = pId + '/' + depth + '-' + i
                } else {
                    element.id = depth + '-' + i
                }
                element.elements = element.elements.map((element_group, i) => {
                    return this.addId(element_group, i, element.id)
                })
            }
        })

        return config
    }

    validateAndPush = () => {
        if (this.props.validate) {
            let new_state = clone(this.state)
            let fields_needing_validation = []

            new_state.config.map(field => {
                let validation_param = field.component_params.find(param => param.name === 'mandatory')
                if (validation_param) {
                    let mandatory = validation_param.value.boolean
                    if (mandatory) {
                        fields_needing_validation.push(field)
                    }
                }
            })
            
            let fields_validation_status = fields_needing_validation.map(field => {
                let value_types = Object.keys(field.value)
                let field_values = value_types.map(type => {
                    return field.value[type]
                })
                let field_has_values = field_values.filter(value => value !== null)
                if (field_has_values.length === 0) {
                    return false
                } else {
                    return true
                }
            })
            let form_validation_status = fields_validation_status.filter(status => status === false).length === 0 ? true : false
            if (!form_validation_status) {
                fields_needing_validation.forEach((field, i) => {
                    let config_field = new_state.config.find(source_field => source_field.name === field.name)
                    if (fields_validation_status[i] === false) {
                        let error_param = {
                            name : 'error',
                            value : {
                                number : null,
                                text : null,
                                list : null,
                                boolean : true
                            }
                        }
                        let has_error = config_field.component_params.find(param => param.name === 'error') ? true : false
                        if (has_error) {
                            if (config_field.component_params.find(param => param.name === 'error').value.boolean === false) {
                                config_field.component_params.find(param => param.name === 'error').value.boolean = true
                            }
                        } else {
                            config_field.component_params.push(error_param)
                        }
                    } else {
                        let error_param = {
                            name : 'error',
                            value : {
                                number : null,
                                text : null,
                                list : null,
                                boolean : null
                            }
                        }

                        let has_error = config_field.component_params.find(param => param.name === 'error') ? true : false
                        if (has_error) {
                            if (config_field.component_params.find(param => param.name === 'error').value.boolean === true) {
                                config_field.component_params.find(param => param.name === 'error').value.boolean = null
                            }
                        } else {
                            config_field.component_params.push(error_param)
                        }

                        config_field.component_params.push(error_param)
                    }

                    let field_index = new_state.config.findIndex(conf_field => conf_field.name === field.name)
                    new_state.config[field_index] = config_field
                 })
            }
            
            this.setState({...new_state}, () => {
                this.props.validation_status(form_validation_status)
                this.props.update_parent(this.state.config)
            })
        } else {
            this.props.update_parent(this.state.config)
        }
    }

    updateValueInConfig = (id, value_type, value) => {
        let new_state = clone(this.state)

        new_state.config = this.updateValue(id, value_type, value, new_state.config)
        this.setState({...new_state}, () => {
            this.props.update_parent(this.state.config)
            //this.validateAndPush()
        })
    }

    updateValue = (id, value_type, value, config) => {
        config.map((element, i) => {
            if (element.component !== 'group') {
                if (element.id === id) {
                    element.value[value_type] = value
                }
            } else {
                element.elements = element.elements.map(element_group => {
                    return this.updateValue(id, value_type, value, element_group)
                })
            }
        })

        return config
    }

    addNewGroup = (group_id) => {
        let new_state = clone(this.state)
        new_state.config = this.addGroup(group_id, new_state.config)
        this.setState({...new_state})
    }

    addGroup = (group_id, config) => {
        config.map(element => {
            if (element.component === 'group') {
                if (element.id === group_id) {
                    element = this.addGroupItem(element)
                } else {
                    element.elements.map(element_group => {
                        this.addGroup(group_id, element_group)
                    })
                }
            }
        })

        return config
    }

    addGroupItem = (group) => {
        let new_group_index = group.elements.length
        let new_group_elements = clone(group.elements[0])
        new_group_elements.map((el, i) => {
            el.id = group.id + "/" + new_group_index + "-" + i
            el.value.text = null
            el.value.number = null
            el.value.list = null
            el.value.boolean = null
        })

        group.elements.push(new_group_elements)

        return group
    }

    deleteLastGroup = (group_id) => {
        let new_state = clone(this.state)
        new_state.config = this.deleteGroup(group_id, new_state.config)
        this.setState({...new_state})
    }

    deleteGroup = (group_id, config) => {
        config.map(element => {
            if (element.component === 'group') {
                if (element.id === group_id) {
                    element = this.deleteGroupItem(element)
                } else {
                    element.elements.map(element_group => {
                        this.deleteGroup(group_id, element_group)
                    })
                }
            }
        })

        return config
    }

    deleteGroupItem = (group) => {
        if (group.elements.length > 1) {
            group.elements.pop()
        }

        return group
    }

    getXsValue = (id, element_sequence, min_xs_value) => {
        let sequence = []

        for (let i = 0; i < element_sequence.length; i++) {
            if (element_sequence[i].includes(id)) {
                sequence = element_sequence[i]
            }
        }

        let temp_xs_val = Math.round(12/sequence.length)
        let xs_value
        if (temp_xs_val <= min_xs_value) {
            xs_value = min_xs_value
        } else {
            xs_value = temp_xs_val
        }

        return xs_value
    }

    addAttachments = (field, attachment) => {
        let new_state = clone(this.state)
        let edit_field = new_state.config.find(fields => fields.name === field)

        if (edit_field.attachments) {
            edit_field.attachments.push(attachment)
        } else {
            edit_field.attachments = [attachment]
        }
        console.log("Adding Field Attachment : ", new_state)
        this.setState({...new_state}, () => this.props.update_parent(this.state.config))
    }


    renderForm = () => {
        console.log("Rendering Form : ", this.state.config)
        let element_sequence = []
        let seq_index = 0
        this.state.config.map(element => {
            if (element.component !== 'group') {
                if (Array.isArray(element_sequence[seq_index])) {
                    element_sequence[seq_index].push(element.id)
                } else {
                    element_sequence[seq_index] = []
                    element_sequence[seq_index].push(element.id)
                }
            } else {
                seq_index++
            }
        })


        let form = this.state.config.map(element => {
            if (element.component !== 'group') {
                let width_param = element.component_params !== null ? element.component_params.findIndex(param => param.name === "width") !== -1 ? element.component_params.find(param => param.name === "width").value.number + "%" : this.props.grid_element_width : this.props.grid_element_width
                return (
                    // <Grid item xs = {this.getXsValue(element.id, element_sequence, min_xs_value)}>
                    //     {Element(element, {
                    //         update_value : (id, value_type, value) => this.updateValueInConfig(id, value_type, value),
                    //         disabled : this.props.disabled
                    //     })}
                    // </Grid>
                    <div 
                        style = {{
                            width : width_param, 
                            padding : '5px'
                        }}>
                        <Paper style = {{
                            width : '100%',
                            padding : '10px'
                        }}
                        variant = 'outlined'
                        >
                            {Element(element, {
                                update_value : (id, value_type, value) => this.updateValueInConfig(id, value_type, value),
                                disabled : this.props.disabled,
                                drl_url : this.props.drl_url,
                                ic_name : this.props.ic_name,
                                add_attachments : (field, attachment) => this.addAttachments(field, attachment),
                                on_open : this.props.on_open,
                                show_attachment : this.props.show_attachment ? this.props.show_attachment : false
                            })}
                        </Paper>
                    </div>
                )
            } else {
                return (
                    // <Grid item xs = {12}>
                    //     {Element(element, {
                    //         update_value : (id, value_type, value) => this.updateValueInConfig(id, value_type, value),
                    //         add_group : (id) => this.addNewGroup(id),
                    //         delete_group : (id) => this.deleteLastGroup(id),
                    //         disabled : this.props.disabled
                    //     })}
                    // </Grid>
                    <div style = {{
                        width : '100%',
                        padding : '5px'
                    }}
                    >
                        {Element(element, {
                            update_value : (id, value_type, value) => this.updateValueInConfig(id, value_type, value),
                            add_group : (id) => this.addNewGroup(id),
                            delete_group : (id) => this.deleteLastGroup(id),
                            disabled : this.props.disabled,
                            drl_url : this.props.drl_url,
                            ic_name : this.props.ic_name,
                            add_attachments : (field, attachment) => this.addAttachments(field, attachment),
                            on_open : this.props.on_open,
                            show_attachment : this.props.show_attachment ? this.props.show_attachment : false
                        })}
                    </div>
                )
            }
        })

        return form
    }

    renderSubmitIcon = () => {
        if (this.state.submit === true) {
            return (
                <CheckCircleOutlined fontSize = 'small' style = {{color : '#4caf50'}}/>
            )
        }
    }

    render() {
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{
                    width : '100%',
                    display : 'flex',
                    flexDirection : 'row',
                    flexWrap : 'wrap',
                    padding : '5px'
                }}>
                    {this.renderForm()}
                </div>
                {/* <Grid container xs = {12} spacing = {1} direction = 'row' wrap = 'wrap'>
                    {this.renderForm()}
                </Grid> */}
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(FlexForm);